export enum DocumentsStatusEnum {
    FILE_ERROR = 'file_error',
    DROPED = 'droped',
    PROVIDE = 'provide',
    WAITING_APPROVAL = 'waiting_approval',
    VALIDATED = 'validated',
    INVALIDATED = 'invalidated'
}
